// extracted by mini-css-extract-plugin
export default {"main":"spinner_main__ZQbLB"};